import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store, { apiService } from "./store/store";
import { ApiServiceProvider } from "./components/api-service-context";
import App from "./.ClientOffice/components/App/App";
import "./styles/global.scss";
import { Slide } from "@material-ui/core";
import { SnackbarProvider } from "notistack";

ReactDOM.render(
  <Provider store={store}>
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      TransitionComponent={Slide}
    >
      <ApiServiceProvider value={apiService}>
        <Router>
          <App />
        </Router>
      </ApiServiceProvider>
    </SnackbarProvider>
  </Provider>,
  document.getElementById("app")
);
